import type { ReactNode } from 'react';
import type { Except } from 'type-fest';

export const Wrap = <TProps extends { children?: ReactNode }>({
    With,
    when,
    props,
    children,
}: {
    With: (props: TProps) => ReactNode;
    when: unknown;
    props: NoInfer<Except<TProps, 'children'>>; // TODO or cb that receives when/whenAll, similar to Show
    children: ReactNode;
}) => {
    if (!when) {
        return children;
    }
    return <With {...(props as TProps)}>{children}</With>;
};
